import { useParams } from "react-router-dom";
import { useUserQuery } from "../monitor/User.state";

/**
 * Retrieves the current user's role for the game specified in the URL parameters.
 * Extracts `game_id` from the route and queries the user state.
 * 
 * @returns {Object|undefined} The game role object for the current user, or undefined if loading/not found.
 */
const useGameRole = () => {
    const { game_id } = useParams();
    const { game: gameRole } = useUserQuery(game_id);
    return gameRole
}

export default useGameRole